const pitchNames = {
    ALL: 'All Pitches',
    Fastball: 'Fastballs',
    Offspeed: 'Offspeed',
    Breaking: 'Breaking',
    CHFS: 'Changeup',
    CUKC: 'Curve',
    SIFT: 'Sinker',
    FF: 'Four Seamer',
    FT: 'Two Seamer',
    SI: 'Sinker',
    FC: 'Cutter',
    FA: 'Fastball',
    CH: 'Changeup',
    FS: 'Split Finger',
    SC: 'Screwball',
    FO: 'Forkball',
    SL: 'Slider',
    ST: 'Sweeper',
    SV: 'Slurve',
    GY: 'Gyro',
    CU: 'Curveball',
    KC: 'Knuckle Curve',
    CS: 'Slow Curve',
    KN: 'Knuckleball',
    EP: 'Eephus',
}

function getPitchName(pitchType) {
    try {
        return pitchNames[pitchType.toUpperCase()] || pitchType
    } catch (e) {
        return ''
    }
}

function orderPitchTypes(typesArr) {
    const pitchOrder = Object.keys(pitchNames)
    return typesArr.sort(
        (a, b) => pitchOrder.indexOf(a) - pitchOrder.indexOf(b)
    )
}

// These subgroups combines offspeed -> changeup but also fastballs.
function orderPitchTypeSubgroups(typesArr) {
    const pitchOrder = [
        'Fastball',
        'Cutter',
        'Slider',
        'Curve',
        'Changeup',
        'Knuckleball',
    ]

    return typesArr.sort(
        (a, b) => pitchOrder.indexOf(a) - pitchOrder.indexOf(b)
    )
}

module.exports = {
    pitchNames,
    getPitchName,
    orderPitchTypes,
    orderPitchTypeSubgroups,
}
